import { render, staticRenderFns } from "./PrintNoteContent.vue?vue&type=template&id=12b794ed&scoped=true"
import script from "./PrintNoteContent.vue?vue&type=script&lang=ts"
export * from "./PrintNoteContent.vue?vue&type=script&lang=ts"
import style0 from "./PrintNoteContent.vue?vue&type=style&index=0&id=12b794ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b794ed",
  null
  
)

export default component.exports